import React, { FC, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  Button,
  Autocomplete,
} from "@mui/material";
import styles from "./GeneralCreateInterview.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";


import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { generateInterviewGPT } from "../../services/interview.service";

const GeneralCreateInterview = ({
  interviewName,
  setInterviewName,
  description,
  setDescription,
  tags, 
  setTags, 
  tagInput, 
  setTagInput, 
  setPrompt,
  setOpenDialog,
  setIsRefining,
  setRefinedPrompt,
  prompt
}: any) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  //general: button back
  const handleGoBack = () => {
    navigate("/my-dashboard");
  };

  // step1: edit prompt
  const handlePrompt = async () => {
    if (!prompt.trim()) {
      return; // No ejecutar si el prompt está vacío
    }

    setOpenDialog(true);
    setIsRefining(true);
    setRefinedPrompt("");

    const refinementPrompt = `Refina y mejora el siguiente prompt para que sea más claro y conciso, manteniendo la esencia y el objetivo del mismo: "${prompt}"`;

    try {
      await generateInterviewGPT(
        refinementPrompt,
        (response: string) => {
          setRefinedPrompt(response);
        },
        setIsRefining
      );
    } catch (error) {
      console.error("Error refinando el prompt:", error);
      setIsRefining(false);
    }
  };

        

  return (
    <div className={styles.summary}>
      <div className={styles.createInterview}>
        <IconButton
          sx={{ position: "absolute", marginLeft: "-120px" }}
          onClick={handleGoBack}
        >
          <ArrowBackIcon />
        </IconButton>
        <h4 style={{ marginTop: "50px", marginBottom: "-20px" }}>
          General Description
        </h4>
        <TextField
          label={t("general.admin.interviewname")}
          variant="standard"
          fullWidth
          margin="normal"
          className={styles.textField}
          value={interviewName}
          onChange={(e) => setInterviewName(e.target.value)}
        />
        <TextField
          label={t("general.admin.description")}
          variant="standard"
          fullWidth
          margin="normal"
          multiline
          className={styles.textField}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <Typography
          variant="body2"
          component="div"
          sx={{
            marginTop: "12px",
            marginBottom: "10px",
            fontSize: "0.8rem",
            color: "#666666",
            fontfamily: "Roboto, sans-serif",
            fontWeight: "400",
            textOverflow: "ellipsis",
          }}
        >
          {"Add tags"} (Press enter to save)
        </Typography>
        <Box className={styles.questionContainer}>
          <Autocomplete
            multiple
            //disableClearable={viewOnly}
            filterSelectedOptions
            options={[]}
            fullWidth
            freeSolo
            //limitTags={3}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              return option?.Label && option.Label;
            }}
            value={tags}
            onChange={(event, newValue) => {
              const formattedTags = newValue.map((item) => {
                if (typeof item === "string") {
                  return { Label: item };
                }
                return item;
              });
              setTags(formattedTags);
            }}
            inputValue={tagInput}
            onInputChange={(event, newInputValue, reason) => {
              if (reason !== 'reset') {
                setTagInput(newInputValue);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && tagInput.trim() !== "") {
                e.preventDefault();
                setTags([...tags, { Label: tagInput }]);
                setTagInput("");
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={t("# Operation")} //!viewOnly ? t("general.admin.email") : ""}
              />
            )}
          />
        </Box>
        <TextField
          label="Prompt"
          variant="standard"
          fullWidth
          margin="normal"
          multiline
          className={styles.textField}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          sx={{ marginTop: "24px" }}
        />
        <Button
          onClick={handlePrompt}
          variant="text"
          startIcon={<AutoAwesomeIcon />}
          style={{
            backgroundColor: "transparent",
            color: "#77a1d3",
            padding: "10px 14px",
            margin: "14px 0px",
            width: "160px",
          }}
        >
          {"Refine Prompt"}
        </Button>
        <TextField
          variant="standard"
          fullWidth
          margin="normal"
          multiline
          className={`${styles.textField} ${styles.AIModel}`}
          value={"GPT-4o"}
        />
      </div>
    </div>
  );
};

export default GeneralCreateInterview;
